import Logo from '../ui/Logo';
import Container from '../ui/Container';
import { motion } from 'framer-motion';

const DetailInfo = () => {
    return (
        <div id="detailinfo" className="py-14 md:py-20">
            <Container>
                <div className="flex justify-between items-center lg:mb-6 overflow-x-hidden">
                    <motion.h3
                        initial={{ opacity: 0, x: 150 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                        className="font-bold text-3xl md:text-4xl max-w-[630px] mb-8 md:mb-12">
                        Детальніше про те, що чекає на вас в{' '}
                        <span className="text-orange">FrogPrivateClub</span>
                    </motion.h3>
                    <Logo />
                </div>

                <div className="flex flex-col 2xl:flex-row items-stretch gap-3 md:gap-10 2xl:gap-14 overflow-x-hidden">
                    <motion.div
                        initial={{ opacity: 0, x: 150 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                        className="text-white bg-darkblue px-3 py-6 lg:p-9 rounded-2xl flex flex-col gap-6 lg:gap-12 2xl:max-w-[640px] w-full">
                        <div className="flex justify-between items-center w-full">
                            <p className="text-[28px] leading-[34px] lg:text-[44px] lg:leading-[54px] font-semibold">
                                База знань
                            </p>
                            <p className="bg-orange px-5 py-2 rounded-[30px] text-[24px] leading-[30px] lg:text-[32px] lg:leading-[39px] font-semibold">
                                Бонус
                            </p>
                        </div>

                        <div className="flex flex-col gap-6">
                            <div className="flex gap-3">
                                <svg
                                    className="shrink-0 w-[54px] h-[54px]"
                                    viewBox="0 0 54 54"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_18_871)">
                                        <path
                                            d="M24.75 9H47.25V13.5H24.75V9ZM24.75 18H38.25V22.5H24.75V18ZM24.75 31.5H47.25V36H24.75V31.5ZM24.75 40.5H38.25V45H24.75V40.5ZM6.75 9H20.25V22.5H6.75V9ZM11.25 13.5V18H15.75V13.5H11.25ZM6.75 31.5H20.25V45H6.75V31.5ZM11.25 36V40.5H15.75V36H11.25Z"
                                            fill="white"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_18_871">
                                            <rect
                                                width="54"
                                                height="54"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>

                                <p className="text-2xl font-medium">
                                    Наш дашборд у Notion із відібраними
                                    проектами і детальними гайдами до них під
                                    опрацювання
                                </p>
                            </div>
                            <div className="flex gap-3">
                                <svg
                                    width="54"
                                    height="54"
                                    className="shrink-0"
                                    viewBox="0 0 54 54"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M18 9H47.25V13.5H18V9ZM11.25 6.75V13.5H13.5V15.75H6.75V13.5H9V9H6.75V6.75H11.25ZM6.75 31.5V25.875H11.25V24.75H6.75V22.5H13.5V28.125H9V29.25H13.5V31.5H6.75ZM11.25 43.875H6.75V41.625H11.25V40.5H6.75V38.25H13.5V47.25H6.75V45H11.25V43.875ZM18 24.75H47.25V29.25H18V24.75ZM18 40.5H47.25V45H18V40.5Z"
                                        fill="white"
                                    />
                                </svg>

                                <p className="text-2xl font-medium">
                                    Середовище, в якому зібрані усі інструкції,
                                    поради та напрацьований досвід команди
                                </p>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 150 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        viewport={{ once: true }}
                        className="bg-gray px-3 py-6 lg:p-9 rounded-2xl flex flex-col gap-12 2xl:max-w-[545px] w-full">
                        <div className="flex flex-col gap-6">
                            <div className="flex gap-3">
                                <svg
                                    width="54"
                                    height="54"
                                    className="shrink-0"
                                    viewBox="0 0 54 54"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_18_893)">
                                        <path
                                            d="M22.5 4.5C23.742 4.5 24.75 5.508 24.75 6.75V15.75C24.75 16.992 23.742 18 22.5 18H18V22.5H29.25V20.25C29.25 19.008 30.258 18 31.5 18H45C46.242 18 47.25 19.008 47.25 20.25V29.25C47.25 30.492 46.242 31.5 45 31.5H31.5C30.258 31.5 29.25 30.492 29.25 29.25V27H18V40.5H29.25V38.25C29.25 37.008 30.258 36 31.5 36H45C46.242 36 47.25 37.008 47.25 38.25V47.25C47.25 48.492 46.242 49.5 45 49.5H31.5C30.258 49.5 29.25 48.492 29.25 47.25V45H15.75C14.508 45 13.5 43.992 13.5 42.75V18H9C7.758 18 6.75 16.992 6.75 15.75V6.75C6.75 5.508 7.758 4.5 9 4.5H22.5ZM42.75 40.5H33.75V45H42.75V40.5ZM42.75 22.5H33.75V27H42.75V22.5ZM20.25 9H11.25V13.5H20.25V9Z"
                                            fill="#030332"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_18_893">
                                            <rect
                                                width="54"
                                                height="54"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>

                                <p className="text-2xl font-medium">
                                    Більше 10 тематичних гілок з перевіреною
                                    інформацією
                                </p>
                            </div>
                            <div className="flex gap-3">
                                <svg
                                    width="54"
                                    height="54"
                                    viewBox="0 0 54 54"
                                    fill="none"
                                    className="shrink-0"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M29.25 18V36C29.25 37.7902 28.5388 39.5071 27.273 40.773C26.0071 42.0388 24.2902 42.75 22.5 42.75H17.6175C17.0867 44.2519 16.0421 45.5177 14.6682 46.3238C13.2943 47.1299 11.6797 47.4243 10.1097 47.1551C8.53975 46.8858 7.11553 46.0702 6.08878 44.8523C5.06204 43.6345 4.4989 42.0929 4.4989 40.5C4.4989 38.9071 5.06204 37.3655 6.08878 36.1477C7.11553 34.9298 8.53975 34.1142 10.1097 33.8449C11.6797 33.5757 13.2943 33.8701 14.6682 34.6762C16.0421 35.4823 17.0867 36.7481 17.6175 38.25H22.5C23.0967 38.25 23.669 38.0129 24.091 37.591C24.5129 37.169 24.75 36.5967 24.75 36V18C24.75 16.2098 25.4612 14.4929 26.727 13.227C27.9929 11.9612 29.7098 11.25 31.5 11.25H38.25V4.5L49.5 13.5L38.25 22.5V15.75H31.5C30.9033 15.75 30.331 15.9871 29.909 16.409C29.4871 16.831 29.25 17.4033 29.25 18ZM11.25 42.75C11.8467 42.75 12.419 42.5129 12.841 42.091C13.2629 41.669 13.5 41.0967 13.5 40.5C13.5 39.9033 13.2629 39.331 12.841 38.909C12.419 38.4871 11.8467 38.25 11.25 38.25C10.6533 38.25 10.081 38.4871 9.65901 38.909C9.23705 39.331 9 39.9033 9 40.5C9 41.0967 9.23705 41.669 9.65901 42.091C10.081 42.5129 10.6533 42.75 11.25 42.75Z"
                                        fill="#030332"
                                    />
                                </svg>

                                <p className="text-2xl font-medium">
                                    Прямі коли/гайди на опрацювання смартідей
                                </p>
                            </div>
                            <div className="flex gap-3">
                                <svg
                                    width="54"
                                    height="54"
                                    viewBox="0 0 54 54"
                                    className="shrink-0"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M4.5 49.5C4.5 44.7261 6.39642 40.1477 9.77208 36.7721C13.1477 33.3964 17.7261 31.5 22.5 31.5C27.2739 31.5 31.8523 33.3964 35.2279 36.7721C38.6036 40.1477 40.5 44.7261 40.5 49.5H36C36 45.9196 34.5777 42.4858 32.0459 39.9541C29.5142 37.4223 26.0804 36 22.5 36C18.9196 36 15.4858 37.4223 12.9541 39.9541C10.4223 42.4858 9 45.9196 9 49.5H4.5ZM22.5 29.25C15.0412 29.25 9 23.2088 9 15.75C9 8.29125 15.0412 2.25 22.5 2.25C29.9588 2.25 36 8.29125 36 15.75C36 23.2088 29.9588 29.25 22.5 29.25ZM22.5 24.75C27.4725 24.75 31.5 20.7225 31.5 15.75C31.5 10.7775 27.4725 6.75 22.5 6.75C17.5275 6.75 13.5 10.7775 13.5 15.75C13.5 20.7225 17.5275 24.75 22.5 24.75ZM41.139 33.0818C44.301 34.5058 46.9845 36.8128 48.8668 39.7253C50.7492 42.6379 51.7504 46.0321 51.75 49.5H47.25C47.2505 46.899 46.4997 44.3531 45.0879 42.1686C43.6762 39.984 41.6634 38.2537 39.2917 37.1858L41.1368 33.0818H41.139ZM39.591 7.67925C41.8579 8.61367 43.7962 10.2005 45.1598 12.2383C46.5234 14.2761 47.2509 16.673 47.25 19.125C47.2509 22.2127 46.0973 25.1893 44.0157 27.4699C41.9341 29.7505 39.075 31.1703 36 31.4505V26.9213C37.6671 26.6825 39.2138 25.9155 40.4129 24.733C41.6121 23.5505 42.4006 22.0147 42.6626 20.3511C42.9246 18.6875 42.6465 16.9837 41.8689 15.4898C41.0913 13.9959 39.8553 12.7907 38.3423 12.051L39.591 7.67925V7.67925Z"
                                        fill="#030332"
                                    />
                                </svg>

                                <p className="text-2xl font-medium">
                                    Щотижневі коли та допомога учасникам в їхній
                                    праці
                                </p>
                            </div>
                            <div className="flex gap-3">
                                <svg
                                    width="54"
                                    height="54"
                                    viewBox="0 0 54 54"
                                    className="shrink-0"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M40.5698 37.3883L50.2065 47.0228L47.0228 50.2065L37.3883 40.5698C33.8034 43.4435 29.3445 45.0065 24.75 45C13.572 45 4.5 35.928 4.5 24.75C4.5 13.572 13.572 4.5 24.75 4.5C35.928 4.5 45 13.572 45 24.75C45.0065 29.3445 43.4435 33.8034 40.5698 37.3883ZM36.0562 35.7188C38.9118 32.7822 40.5065 28.846 40.5 24.75C40.5 16.047 33.4508 9 24.75 9C16.047 9 9 16.047 9 24.75C9 33.4508 16.047 40.5 24.75 40.5C28.846 40.5065 32.7822 38.9118 35.7188 36.0562L36.0562 35.7188V35.7188ZM27.4005 16.146C26.737 16.4457 26.1562 16.9019 25.7078 17.4754C25.2594 18.049 24.9569 18.7227 24.8261 19.4389C24.6954 20.1551 24.7404 20.8923 24.9572 21.5872C25.174 22.2822 25.5562 22.9142 26.071 23.429C26.5858 23.9438 27.2178 24.326 27.9128 24.5428C28.6077 24.7596 29.3449 24.8046 30.0611 24.6739C30.7773 24.5431 31.451 24.2406 32.0246 23.7922C32.5981 23.3438 33.0543 22.763 33.354 22.0995C33.9453 24.0202 33.8768 26.0835 33.1593 27.9606C32.4419 29.8378 31.1168 31.4209 29.3953 32.4576C27.6737 33.4943 25.6547 33.925 23.6599 33.6811C21.6652 33.4371 19.8094 32.5326 18.3884 31.1116C16.9674 29.6906 16.0629 27.8348 15.8189 25.8401C15.575 23.8453 16.0057 21.8263 17.0424 20.1047C18.0791 18.3832 19.6622 17.0581 21.5394 16.3407C23.4165 15.6232 25.4798 15.5547 27.4005 16.146V16.146Z"
                                        fill="#030332"
                                    />
                                </svg>

                                <p className="text-2xl font-medium">
                                    Ресьорчі та огляди на проекти і події
                                </p>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 150 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                        viewport={{ once: true }}
                        className="px-3 py-6 lg:p-9 rounded-2xl flex flex-col gap-12 w-full">
                        <p className="text-[28px] leading-[34px] font-medium">
                            Усе це у максимально зручному вигляді – в телеграмі,
                            що дає вам можливість з легкістю швидко
                            ознайомлюватись з матеріалами та моніторити коли від
                            менторів
                        </p>
                    </motion.div>
                </div>
            </Container>
        </div>
    );
};

export default DetailInfo;
